// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';

type Props = {
  children?: React.Node,
  /** Determines if the dropdown is open or closed **/
  isOpen: boolean,
  /** Shows the main button that leads to the dropdown **/
  summaryNode: React.Node,
};

const summaryCss = {
  display: 'block',
  '&::-webkit-details-marker': {
    display: 'none',
  },
};

const DropdownDetails = (props: Props) => {
  const { isOpen, summaryNode, children } = props;
  return (
    <details open={isOpen}>
      <summary css={summaryCss}>{summaryNode}</summary>
      {children}
    </details>
  );
};

export default DropdownDetails;
